<template>
  <div class="page-container">
    <!-- 头部 -->
    <section>
      <com-header></com-header>
    </section>

    <!-- nav -->
    <section>
      <com-nav></com-nav>
    </section>

    <!-- 内容部分 -->
    <section>
      <div class="page-content">
        <div class="line-mask"></div>
        <div class="page-area">
          <section>
            <swiper class="swiper-container" :options="swiperOption">
              <swiper-slide
                class="swiper-slide"
                v-for="(item, index) in bannerList"
                :key="index"
              >
                <img :src="item.url" alt="" />
              </swiper-slide>
              <!-- <div class="swiper-pagination" slot="pagination"></div> -->
              <div class="swiper-button-prev" slot="button-prev"></div>
              <div class="swiper-button-next" slot="button-next"></div>
            </swiper>
          </section>

          <p class="set-name">{{ name }}</p>

          <section>
            <div class="product-group">
              <div class="product-item" v-for="(item, index) in productList" :key="index">
                <div class="item-cont">
                  <img :src="item.url" alt="" />
                  <div class="product-name">{{item.name}}</div>
                </div>
              </div>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import comHeader from "../components/comheader.vue";
import comNav from "../components/comnav.vue";
export default {
  name: "set",
  data() {
    return {
      name: "",
      productList: [],
      bannerList: [],
      id: "",
      swiperOption: {
        slidesPerView: 1,
        // 设置自动轮播
        autoplay: {
          delay: 4000,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        loop: true,
      },
    };
  },
  components: {
    comHeader: comHeader,
    comNav: comNav,
  },
  created() {
    let id = this.$route.params.id;
    if (!id) {
      this.$router.push("/index");
      return;
    }
    this.id = id;
    this.initSetData(id);
  },
  watch: {
    $route: {
      handler(val, oldval) {
        if (val && val.params && val.params.id != this.id) {
          this.id = val.params.id;
          this.initSetData(val.params.id);
        }
      },
      // 深度观察监听
      deep: true,
    },
  },
  methods: {
    initSetData(id) {
      id = parseInt(id);
      let name = "",
        bannerList = [
          { url: require("../assets/set/" + id + "/banner1.jpg") },
          { url: require("../assets/set/" + id + "/banner2.jpg") },
        ],
        productList = [],
        productnum = 0;
      switch (id) {
        case 1:
          name = "经典系列";
          productnum = 18;
          productList = [
            { url: require("../assets/set/1/1.jpg"),name:'编金戒'},
            { url: require("../assets/set/1/2.jpg"),name:'云纹戒'},
            { url: require("../assets/set/1/7.jpg"),name:'五福梅形珍珠项坠'},
            { url: require("../assets/set/1/3.jpg"),name:'花开宝相镶玛瑙香盒项坠'},
            { url: require("../assets/set/1/4.jpg"),name:'波涛纹螭龙圆盘项坠'},
            { url: require("../assets/set/1/5.jpg"),name:'画珐琅牡丹项坠'},
            { url: require("../assets/set/1/8.jpg"),name:'蜕蝉梦蝶项坠'},
            { url: require("../assets/set/1/6.jpg"),name:'双鲤戏珠项坠'},
            { url: require("../assets/set/1/10.jpg"),name:'锦绣繁华手镯'},
            { url: require("../assets/set/1/13.jpg"),name:'琴迪亚手镯'},
            { url: require("../assets/set/1/16.jpg"),name:'花丝路路通手串'},
            { url: require("../assets/set/1/17.jpg"),name:'花丝蝴蝶'},
            // { url: require("../assets/set/1/9.jpg"),name:'花丝流盼耳环'},
            // { url: require("../assets/set/1/11.jpg"),name:'花丝手链'},
            // { url: require("../assets/set/1/12.jpg"),name:'瑞彩祥云金环'},
            // { url: require("../assets/set/1/14.jpg"),name:'花丝合镯'},
            // { url: require("../assets/set/1/15.jpg"),name:'1'},
            // { url: require("../assets/set/1/18.jpg"),name:'花丝莲纹金碗'}
          ]
          break;
        case 2:
          name = "景福系列";
          productnum = 20;
          productList = [
            { url: require("../assets/set/2/7.jpg"),name:'点梅十字海棠项坠'},
            { url: require("../assets/set/2/8.jpg"),name:'喜上梅梢十字海棠项坠'},
            { url: require("../assets/set/2/6.jpg"),name:'麒麟十字海棠项坠'},
            { url: require("../assets/set/2/5.jpg"),name:'牡丹十字海棠项坠'},
            { url: require("../assets/set/2/12.jpg"),name:'画珐琅福禄—梅'},
            { url: require("../assets/set/2/13.jpg"),name:'画珐琅福禄—兰'},
            { url: require("../assets/set/2/14.jpg"),name:'画珐琅福禄—竹'},
            { url: require("../assets/set/2/11.jpg"),name:'画珐琅福禄—菊'},
            { url: require("../assets/set/2/16.jpg"),name:'福禄生肖（寅虎）'},
            { url: require("../assets/set/2/17.jpg"),name:'福禄生肖（午马）'},
            { url: require("../assets/set/2/19.jpg"),name:'福禄生肖（申猴）'},
            { url: require("../assets/set/2/18.jpg"),name:'福禄生肖（酉鸡）'},
            { url: require("../assets/set/2/1.jpg"),name:'明式金摺丝葫芦耳环'},
            { url: require("../assets/set/2/2.jpg"),name:'花丝金福禄'},
            { url: require("../assets/set/2/15.jpg"),name:'画珐琅福禄—牡丹'},
            { url: require("../assets/set/2/20.jpg"),name:'画珐琅福袋'}
            // { url: require("../assets/set/2/3.jpg"),name:'金福禄'},
            // { url: require("../assets/set/2/4.jpg"),name:'宝葫芦'},
            // { url: require("../assets/set/2/9.jpg"),name:'双蝠捧寿画珐琅福禄'},
            // { url: require("../assets/set/2/10.jpg"),name:'瑞蚨圆盘项坠'}
          ]
          break;
        case 3:
          name = "麟趾系列";
          productnum = 8;
          productList = [
            { url: require("../assets/set/3/2.jpg"),name:'百福日生金锁'},
            { url: require("../assets/set/3/4.jpg"),name:'双蝠捧财金锁'},
            { url: require("../assets/set/3/1.jpg"),name:'双蝠捧运镶玛瑙金锁'},
            { url: require("../assets/set/3/3.jpg"),name:'福在眼前金锁'},
            { url: require("../assets/set/3/5.jpg"),name:'岁岁平安金锁'},
            { url: require("../assets/set/3/7.jpg"),name:'凤毛麟角金锁'},
            { url: require("../assets/set/3/8.jpg"),name:'天赐福禄金锁'},
            { url: require("../assets/set/3/6.jpg"),name:'缠枝莲纹锁'}
          ]
          break;
        case 4:
          name = "明德系列";
          productnum = 8;
          productList = [
            { url: require("../assets/set/4/3.jpg"),name:'清·金质累丝宫灯状耳坠'},
            { url: require("../assets/set/4/2.jpg"),name:'清·金质累丝宫灯状耳坠'},
            { url: require("../assets/set/4/1.jpg"),name:'双龙戏珠金镯'},
            { url: require("../assets/set/4/6.jpg"),name:'国礼·繁花手包挂坠'},
            { url: require("../assets/set/4/5.jpg"),name:'明·螭龙对杯'},
            // { url: require("../assets/set/4/4.jpg"),name:'唐·飞禽唐草纹蚌形项坠'},
            { url: require("../assets/set/4/13.jpg"),name:'菊瓣缠枝莲花纹金碗'},
            { url: require("../assets/set/4/10.jpg"),name:'复刻唐鸳鸯莲瓣纹金碗'},
            { url: require("../assets/set/4/9.jpg"),name:'宋·龙纹金杯'},
            { url: require("../assets/set/4/7.jpg"),name:'吉祥如意'},
            { url: require("../assets/set/4/12.jpg"),name:'金龙鱼'},
            { url: require("../assets/set/4/11.jpg"),name:'画珐琅花丝孔雀'},
            { url: require("../assets/set/4/8.jpg"),name:'福衢寿车·花丝华盖'},
          ]
          break;
        case 5:
          name = "琴瑟系列";
          productnum = 15;
          productList = [
            { url: require("../assets/set/5/3.jpg"),name:'龙鳞·凤翎平安扣项坠'},
            { url: require("../assets/set/5/5.jpg"),name:'龙鳞·凤翎香筒项坠'},
            { url: require("../assets/set/5/4.jpg"),name:'龙凤和鸣香囊项坠'},
            { url: require("../assets/set/5/2.jpg"),name:'龙鳞·凤翎金镯'},
            { url: require("../assets/set/5/10.jpg"),name:'累丝镶百宝蝴蝶金簪'},
            { url: require("../assets/set/5/8.jpg"),name:'累丝嵌玛瑙蝴蝶金簪'},
            { url: require("../assets/set/5/7.jpg"),name:'画珐琅蝴蝶金簪'},
            { url: require("../assets/set/5/9.jpg"),name:'明式镶玛瑙金钗'},
            { url: require("../assets/set/5/15.jpg"),name:'花丝香盒'},
            { url: require("../assets/set/5/12.jpg"),name:'鸳鸯信物盒'},
            { url: require("../assets/set/5/13.jpg"),name:'子孙桶（统）子孙壶（福）'},
            { url: require("../assets/set/5/14.jpg"),name:'福禄鸳鸯摆件'}
            // { url: require("../assets/set/5/1.jpg"),name:'1'},
            // { url: require("../assets/set/5/6.jpg"),name:'蝶恋花金簪'},
            // { url: require("../assets/set/5/11.jpg"),name:'画珐琅蝴蝶胸针'},
          ]
          break;
        case 6:
          name = "慎独系列";
          productnum = 4;
          productList = [
            { url: require("../assets/set/6/1.jpg"),name:'如意金蝉'},
            { url: require("../assets/set/6/5.jpg"),name:'万代盘长福禄金碗'},
            { url: require("../assets/set/6/6.jpg"),name:'花丝连纹金碗'},
            { url: require("../assets/set/6/7.jpg"),name:'缠枝连纹金碗'},
            { url: require("../assets/set/6/3.jpg"),name:'夔龙壶'},
            { url: require("../assets/set/6/2.jpg"),name:'万代盘长福禄'},
            { url: require("../assets/set/6/4.jpg"),name:'竹韵凌霄金壶 、杯'},
            { url: require("../assets/set/6/8.jpg"),name:'宝葫芦'}
          ]
          break;
        case 7:
          name = "唐彩系列";
          productnum = 11;
          productList = [
            { url: require("../assets/set/7/6.jpg"),name:'芙蓉锦鲤托帕坠'},
            { url: require("../assets/set/7/10.jpg"),name:'画珐琅芙蓉锦鲤黄晶坠'},
            { url: require("../assets/set/7/1.jpg"),name:'画珐琅太阳花紫晶坠'},
            { url: require("../assets/set/7/7.jpg"),name:'芙蓉托帕水滴项坠'},
            { url: require("../assets/set/7/4.jpg"),name:'画珐琅三叶黄晶方形坠'},
            { url: require("../assets/set/7/9.jpg"),name:'唐彩花蝶纹黄晶如意坠'},
            { url: require("../assets/set/7/2.jpg"),name:'托帕如意联结坠'},
            { url: require("../assets/set/7/3.jpg"),name:'芙蓉托帕方形坠'},
            { url: require("../assets/set/7/5.jpg"),name:'芙蓉黄晶十字坠'},
            // { url: require("../assets/set/7/6.jpg"),name:'芙蓉锦鲤托帕坠'},
            { url: require("../assets/set/7/8.jpg"),name:'芙蓉托帕十字项坠'},
            { url: require("../assets/set/7/11.jpg"),name:'芙蓉托帕花型坠'}
          ]
          break;
        case 8:
          name = "无为系列";
          productnum = 9;
          productList = [
            { url: require("../assets/set/8/3.jpg"),name:'灵动观音项坠'},
            { url: require("../assets/set/8/2.jpg"),name:'灵动飞天项坠'},
            { url: require("../assets/set/8/1.jpg"),name:'吉祥八宝圆盘项坠'},
            { url: require("../assets/set/8/4.jpg"),name:'佛法圆轮六字明言项坠'},
            { url: require("../assets/set/8/6.jpg"),name:'谛听兽首圆盘项坠'},
            { url: require("../assets/set/8/7.jpg"),name:'八吉祥圆盘项坠'},
            { url: require("../assets/set/8/5.jpg"),name:'绿救度佛母金像'},
            { url: require("../assets/set/8/9.jpg"),name:'招财纳福弥勒坐像'}
            // { url: require("../assets/set/8/8.jpg"),name:'葵口八吉祥金碗'},
          ]
          break;
        case 9:
          name = "真武系列";
          productnum = 4;
          productList = [
            { url: require("../assets/set/9/1.jpg"),name:'青龙圆盘项坠'},
            { url: require("../assets/set/9/2.jpg"),name:'白虎圆盘项坠'},
            { url: require("../assets/set/9/3.jpg"),name:'朱雀圆盘项坠'},
            { url: require("../assets/set/9/4.jpg"),name:'玄武灵动圆盘项坠'}
          ]
          break;
        default:
          break;
      }
      if (!name && !bannerList.length && !productList.length) {
        this.$router.push("/set/1");
        return;
      }
      this.name = name;
      this.bannerList = bannerList;
      this.productList = productList;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.page-container {
  width: 100%;
  .page-content {
    position: relative;
    width: 100%;
    padding-bottom: 150px;
    // background-color: #fbeecb;
    .line-mask {
      position: absolute;
      top: 0;
      bottom: 0;
      left: 0;
      right: 0;
      z-index: 1;
      background-image: url("../assets/setbottomline.png");
      background-repeat: repeat-y;
      background-size: 100% auto;
      background-position: top left;
    }
    .page-area {
      position: relative;
      z-index: 2;
    }
    .swiper-container {
      width: 100%;
      .swiper-slide {
        width: 100%;
        overflow: hidden;
        cursor: pointer;
        img {
          width: 100%;
          display: block;
          height: auto;
        }
      }
    }
    .set-name {
      margin-top: 110px;
      text-align: center;
      font-size: 36px;
      letter-spacing: 30px;
      color:#444;
    }
    .product-group {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      margin-top: 110px;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
      flex-wrap: wrap;
      .product-item {
        margin:50px 0;
        padding: 0 25px;
        max-width: 300px;
        width: 25%;
        cursor: pointer;
        @media (max-width: 899px) {
          width: 33.3333%;
        }
        @media (max-width: 599px) {
          width: 50%;
        }
        .item-cont {
          width: 100%;
          transition: all 0.3s;
          &:hover {
            transform: scale(1.02);
			      box-shadow:5px 5px 20px 5px rgba(0,0,0,0.15);
            .product-name {
              color: #363636;
            }
          }
          img {
            display: block;
            width: 100%;
          }
          .product-name {
            letter-spacing: 6px;
            width: 100%;
            height: 50px;
            text-align: center;
            font-size: 14px;
            color: #777;
            line-height: 30px;
            background: #fff;
            display:flex;
            align-items: center;
            justify-content: center;
            flex-wrap: wrap;
            color: #9a9a9a;
          }
        }
      }
    }
  }
}
.swiper-button-prev,
.swiper-button-next {
  color: #f4dba0;
}
</style>

<style>
.swiper-button-prev,
.swiper-button-next {
  color: #f4dba0;
}
</style>



// WEBPACK FOOTER //
// src/pages/set.vue